<template>
  <div class="mit-my-borrowed-list">
    <MitDataTableClient
      title="Borrowed"
      :editable="false"
      :headers="headers"
      :items="borrowed"
    >
    </MitDataTableClient>
  </div>
</template>

<script>
import MitBorrowService from '../../services/MitBorrowService.js';
import MitDataTableClient from '../common/MitDataTableClient.vue';

export default {
  name: 'MitMyBorrowedList',
  components: {
    MitDataTableClient
  },
  props: {
  },
  data: function() {
    return {
      search: '',
      headers:[
          {text: 'Key',sortable: true,value: 'keyName',},
          // temporary hiding spaces
          // {text: 'Spaces',sortable: false,value: 'accessSpacesDisplay',},
          {text: 'Borrowed Date',sortable: true,value: 'dates_local.checkoutDt',}
        ],
      borrowed:[]
    }
  },
  mounted() {
    MitBorrowService.requestGetMyBorrowedKeys()
      .then((data) => {
        this.borrowed = data;
      })
      .catch((error) => {
        console.log('An error occurred trying to get keys list', error);
      });
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
</style>
